/*
 *   File : success.js
 *   Author : https://evoqins.com
 *   Description : Success modal component
 *   Integrations : NA
 *   Version : 1.0.0
*/

import React, { memo } from 'react';

// Custom component 
import { PrimaryButton } from '../Buttons';

const SuccessModal = (props) => {

    // handle close modal
    const _handleCloseModal = () => {
        var button = document.getElementById("success-modal-close");
        button.click();
        props.handleClose();
    };


    return (
        <div className="modal fade" id="success-modal" data-bs-backdrop="static" data-bs-keyboard="false" tabIndex="-1" aria-labelledby="approveRequestModalLabel" aria-hidden="true">
            <div className="modal-dialog modal-dialog-centered e-border-radius-24">
                <div className="modal-content e-border-radius-8">
                    <div className="modal-header px-4 pt-4 pb-2 border-0 align-items-start">
                        <img src={require("../../Assets/Image/CountryAdmin/success-icon.svg").default}
                            draggable={false}
                            alt='icon' />
                        <img src={require("../../Assets/Image/CountryAdmin/close-icon.svg").default}
                            draggable={false}
                            className='cursor-pointer'
                            alt='close'
                            onClick={_handleCloseModal} />
                        <button type="button" id='success-modal-close' className="btn-close shadow-none d-none" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div className="modal-body px-4 pb-4 pt-0">
                        <h6 className='mb-2 e-primary-font-playfair e-font-18 e-text-raisin-black e-font-weight-500 line-height-28px'>
                            {props.title}
                        </h6>
                        <p className='mb-0 e-text-davys-grey e-alt-font-noto-sans e-font-14 e-font-weight-400 line-height-20px'>
                            {props.description}
                        </p>
                        <div className='pt-4 mt-1'>
                            <PrimaryButton name="Ok"
                                className="w-100"
                                onPress={_handleCloseModal} />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default memo(SuccessModal);